__webpack_require__.p = "https://web-pre-hbtkmx.blackcore.com.mx/";